import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_widget_indicator = _resolveComponent("widget-indicator")!

  return (_openBlock(), _createBlock(_component_widget_indicator, {
    title: _ctx.$t('dashboard.gas_alarm_indicator.title'),
    description: _ctx.$t('dashboard.gas_alarm_indicator.description'),
    value: _ctx.count,
    variation: _ctx.variation,
    variationColor: _ctx.color,
    "active-color": "danger",
    colorClass: "has-text-success"
  }, null, 8 /* PROPS */, ["title", "description", "value", "variation", "variationColor"]))
}